/** Allow currency labels to wrap without breaking protected digit-grouping spaces. */
export function withBreakableCurrencySpacing(label: string): string {
	return label.replace(
		/(?<=\P{Nd})[\u00a0\u202f](?=[+\-−]?\p{Nd})|(?<=\p{Nd})[\u00a0\u202f](?=\P{Nd})/gu,
		" ",
	);
}

/** Measure protected price segments, retaining grouping spaces but ignoring direction marks. */
export function getLongestMoneySegmentLength(label: string): number {
	return withBreakableCurrencySpacing(label)
		.replace(/\p{Cf}/gu, "")
		.split(/[ \t\r\n]+/u)
		.reduce((longest, segment) => Math.max(longest, Array.from(segment).length), 0);
}
